var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgDownload = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M12 3.3a.7.7 0 0 1 .7.7v10.31l2.806-2.805a.7.7 0 0 1 .99.99l-4 4a.7.7 0 0 1-.99 0l-4-4a.7.7 0 0 1 .99-.99L11.3 14.31V4a.7.7 0 0 1 .7-.7"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M4 15.3a.7.7 0 0 1 .7.7v2A1.3 1.3 0 0 0 6 19.3h12a1.3 1.3 0 0 0 1.3-1.3v-2a.7.7 0 1 1 1.4 0v2a2.7 2.7 0 0 1-2.7 2.7H6A2.7 2.7 0 0 1 3.3 18v-2a.7.7 0 0 1 .7-.7"
})));
export default SvgDownload;